import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'utils/libraries/query-string';
import './index.scss';

const StarConnectHelp = ({ location }) => {
  const params = queryString.parse(location.search);

  return (
    <div className="split__content">
      <div className="left__content">
        <div className="section__card">
          <h2>Prerequisites</h2>
          <p>
            Fatsoma Tabb only integrates with Star printers with CloudPRNT
            Technology. If your printer does not have this technology, it cannot
            be integrated.
            <br />
            <br />
            Your Star printer needs to be connected to the internet to receive
            orders.
          </p>
        </div>

        <div className="section__card">
          <h2>Setup Your Printer</h2>
          <p>
            Make sure your printer is connected to the internet and{' '}
            <strong>turn it off</strong>. <br />
            <br />
            Follow these steps to print out a Network Configuration Slip (as
            shown in the image):
            <br />
            <br />
          </p>

          <ol>
            <li>Hold the FEED button</li>
            <li>While holding the FEED button, power on the printer</li>
            <li>
              Keep holding the FEED button until the printer prints out the
              Network Configuration Slip.
            </li>
          </ol>
        </div>

        <div className="section__card">
          <h2>Set Star CloudPRNT Settings</h2>

          <p>
            In order to change your CloutPRNT settings, you need to use a device
            that is connected to the same network as your printer. Using that
            device, follow these steps:
          </p>

          <ol>
            <li>Open your browser (Chrome, Firefox, etc)</li>
            <li>
              Find the "IP Address" at the bottom of the Network Configuration
              Slip you printed earlier
            </li>
            <li>
              Type this value into the URL bar and navigate to that address
            </li>
            <li>
              Click "Login" in the Navigation Panel
              <ul>
                <li>
                  The default credentials for Star Printers are usually:
                  <ul>
                    <li>
                      Username: <strong>root</strong>
                    </li>
                    <li>
                      Password: <strong>public</strong>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>Click CloudPRNT in the navigation panel</li>
            {params.url && (
              <li>
                Enter the following text into "Server URL"
                <ul>
                  <li>
                    <strong>{params.url}</strong>
                  </li>
                </ul>
              </li>
            )}
            {!params.url && (
              <li>Enter the URL we gave you into "Server URL"</li>
            )}
            <li>Click "Submit"</li>
            <li>Click "Save" in the Navigation Panel</li>
            <li>Save and Restart your Printer</li>
          </ol>
        </div>
      </div>
      <div className="right__content">
        <img
          className="printer__img"
          alt="printer with receipt"
          src="https://imgur.com/gQ7CWyx.png"
        />
      </div>
    </div>
  );
};

export default withRouter(props => <StarConnectHelp {...props} />);



// WEBPACK FOOTER //
// ./src/components/Help/StarConnect/index.jsx